export default __webpack_public_path__ + "static/media/logo-title.7dfd3a83.svg";